<template>
    <div class="page">
      <form class="form-main" id = "form" onsubmit="return false">
        <h3 class="head">Bulk Upload Videos</h3>
        <div class="form-group">
          <label id="label-file">
            <div class="file-upload-wrap">
              <h6 v-if="message">{{ message }}</h6>
              <input name = "inputFile" id="file" type='file'
                  multiple v-on:change="onFileSeleted( $event )" accept=".csv"/>
              <b-button class="mr-2" variant="primary" size="md" type="submit" v-on:click="onUpload()" :disabled=isDisabled>Upload</b-button>
              <div>
                <table id="bulk-table">
                  <tr id="bulk-tr">
                    <th id="bulk-th">Uploaded</th>
                    <th id="bulk-th">Failed</th>
                    <th id="bulk-th">Existed</th>
                  </tr>
                  <tr id="bulk-tr">
                    <th id="bulk-th">{{ SUCCESS }}</th>
                    <th id="bulk-th">{{ FAILED }}</th>
                    <th id="bulk-th">{{ EXISTS }}</th>
                  </tr>
                </table>
                <table></table>
            </div>
            </div>
          </label>
        </div>
      </form>
      <a target="_blank" href="https://drive.google.com/file/d/18z5jQhbedgjrYzAvZBoI1YfcuukcZh4q/view?usp=sharing">Download Template</a> 
    </div>
</template>
    
<script>
    import api from '../../api.js';
    export default {
      name: 'App',
      data: function() {
        return {
          selectedFile: '',
          message: false,
          SUCCESS: 0,
          EXISTS: 0,
          FAILED: 0,
          isDisabled:false
        };
      },
      methods: {
        onFileSeleted(event) {
          this.message = false;
          this.selectedFile = event.target.files;
        },
        async onUpload() {
          this.message = false;
          const data = new FormData();
          const csvFile = document.querySelector('#file');
          data.append('file', csvFile.files[0]);
          try {
            this.message = "Bulk Upload Submitted";
            let response = await api.bulkUploadVideos(data);
            this.isDisabled = true;
            if (response.status == 200) {
              this.SUCCESS = response.SUCCESS,
              this.EXISTS = response.EXISTS,
              this.FAILED = response.FAILED,
              this.message = response.message
            }
            this.isDisabled = false;
          }
          catch(error) {
            this.message = "Bulk Upload Failed";             
          }
        },
  },
    
};
</script>
    
<style>
    @import "~ag-grid-community/styles/ag-grid.css";
    @import "~ag-grid-community/styles/ag-theme-alpine.css";
#bulk-table, #bulk-tr, #bulk-th{
    border:2px solid black;
    margin-top: 15px;
    padding: 10px;
}
</style>
    